import { LayoutType } from 'src/filing/api';

import { apiFetch, UseFetchData, useFetchData, UseFetchOne, useFetchOne } from '../shared/web-api-utils';

export enum AutoConfirmOptionMode {
  DefaultOff = 0,
  DefaultOn = 1,
  Disabled = 2,
}

export enum DeploymentModeEnum {
  Normal = 0,
  LimitReached = 1,
}

export enum ServiceProviderAccountType {
  Full = 1,
  Restricted = 2,
  Demo = 3,
}

export interface UserOptions {
  autoConfirmOptionMode: AutoConfirmOptionMode;
  beaconEnabled: boolean;
  canCreateModelBaseFiling?: boolean;
  canExportInvalidFilings: boolean;
  /** In seconds */
  companiesHouseXmlGatewayTimeout: number;
  defaultLayoutType?: LayoutType;
  deploymentMode: DeploymentModeEnum;
  enableFixedLayout?: boolean;
  enableUpdateInPlace: boolean;
  epubAndXhtmlEnabled: boolean;
  filerEditLockEnabled: boolean;
  filingHistoryMax: number;
  hasExtendableTaxonomies: boolean;
  hasFilingLimit?: boolean;
  inlineXbrlImportEnabled: boolean;
  interactiveIxbrlEnabled: boolean;
  language: string;
  languages: string[];
  pdfEnabled: boolean;
  serviceProviderAccountType?: ServiceProviderAccountType;
  userAccountUrl: string;
}

export async function getUserOptions(): Promise<UserOptions> {
  return apiFetch<UserOptions>('user/options');
}

export function useUserOptions(): UseFetchOne<UserOptions> {
  return useFetchOne<UserOptions>('user/options', 'Failed to fetch user options');
}

export interface FilerEntityType {
  id: number;
  description: string;
  typeLabel: string;
  validationRegEx?: string;
  validationMessage?: string;
}

export function useFilerEntityTypes(): UseFetchData<FilerEntityType> {
  return useFetchData<FilerEntityType>(`user/filer-entity-types`, 'Unable to fetch filer entity types');
}
